import { Injectable } from '@angular/core';
import { JsonHttpService } from '../../shared/http/json-http.service';
import { McpServerEntity } from '../models/mcp-server';
import { HttpParams } from '@angular/common/http';
import { DataFieldGroup, DataFieldValue } from 'src/app/shared/datafields/models';

@Injectable({
    providedIn: 'root'
})
export class McpServerService {

    constructor(private httpService: JsonHttpService) { }

    getMcpServers(): Promise<McpServerEntity[]> {
        return this.httpService.get('/api/transport/mcp-servers/get-mcp-servers').toPromise();
    }

    saveMcpServer(entity: McpServerEntity, datafieldValues: DataFieldValue[]): Promise<McpServerEntity> {
        const saveObject = {
            McpServer: entity,
            Values: datafieldValues
        };
        return this.httpService.post('/api/transport/mcp-servers/save-mcp-server', saveObject, null, false).toPromise();
    }

    deleteMcpServer(id: number) {
        const options = { params: new HttpParams().set('mcpServerId', id.toString()) };
        return this.httpService.post('/api/transport/mcp-servers/delete-mcp-server', null, options, false).toPromise();
    }

    getMcpServerDataFieldGroups(artifactId: string, mcpServerId?: number): Promise<DataFieldGroup[]> {
        const options = { params: new HttpParams().set('artifactId', artifactId) };
        if (mcpServerId) {
            options.params = options.params.set('mcpServerId', mcpServerId);
        }
        return this.httpService.get('/api/transport/mcp-servers/get-mcp-server-datafields', options).toPromise();
    }

    getBaseApiUrl(): Promise<string> {
        return this.httpService.get('/api/transport/mcp-servers/get-base-api-url').toPromise();
    }
}
